module.exports = __webpack_public_path__ + "static/media/cabecalho-online.3afbea86.png";